// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__KiBE0","range":"MonthRangeSwitch_range__-Ou-E","disabled":"MonthRangeSwitch_disabled__PrnBq"};